import React from 'react';
import styles from './CommonButton.module.css'


export class CommonButton extends React.Component {
    render() {
        let cls;

        if (this.props.type === 'round') {
            switch (this.props.size) {
                case "extra-small":
                    cls = styles.button_round_extra_small;
                    break;
                case "smaller":
                    cls = styles.button_round_smaller;
                    break;
                case "small":
                    cls = styles.button_round_small;
                    break;
                case "medium":
                    cls = styles.button_round_medium;
                    break;
                case "large":
                    cls = styles.button_round_large;
                    break;
                case "extra-large":
                    cls = styles.button_round_extra_large;
                    break;
                default:
                    cls = styles.button_round_small;
                    break;
            }
        } else {
            switch (this.props.size) {
                case "extra-small":
                    cls = styles.button_extra_small;
                    break;
                case "smaller":
                    cls = styles.button_smaller;
                    break;
                case "small":
                    cls = styles.button_small;
                    break;
                case "medium":
                    cls = styles.button_medium;
                    break;
                case "large":
                    cls = styles.button_large;
                    break;
                case "extra-large":
                    cls = styles.button_extra_large;
                    break;
                default:
                    cls = styles.button_small;
                    break;
            }
        }

        if (this.props.onClick) {
            cls += " " + styles.link_appearance;
        }

        if (this.props.className) {
            cls += " " + this.props.className;
        }

        return (
            <div title={this.props.title} id="common_button" className={'fa-layers fa-fw ' + cls} onClick={this.props.onClick}>
                {this.props.children}
            </div>
        );
    }
}